// src/Components/LanguageSelector.js
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

const LanguageSelector = ({ onLanguageChange }) => {
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const savedLanguage = Cookies.get("selectedLanguage") || "en";
    setLanguage(savedLanguage);
    onLanguageChange(savedLanguage); // sync with parent
  }, []);

  const handleChange = (e) => {
    const newLang = e.target.value;
    setLanguage(newLang);
    Cookies.set("selectedLanguage", newLang, { expires: 365 });
    onLanguageChange(newLang);
  };

  return (
    <div className="translate">
      <select value={language} onChange={handleChange}>
        <option value="Kn">ಕನ್ನಡ</option>
        <option value="en">English</option>
        <option value="Hi">हिंदी</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
